import { render, staticRenderFns } from "./Premiums.vue?vue&type=template&id=397bbc2c&"
import script from "./Premiums.vue?vue&type=script&lang=js&"
export * from "./Premiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports